import {TRootState} from '../../state/store';

export const makeOfflineDocument = (
  stateData: TRootState,
): string => `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">
<html xmlns="http://www.w3.org/1999/xhtml" xml:lang="en" lang="en">
  <head>
  	<meta charset="utf-8" />
    <meta http-equiv="content-type" content="text/html; charset=utf-8" />
    <title>EVDense - Timeline</title>
    <style>#uberdiv {
	width: 979px;
	min-height: 675px;
	margin-left: auto;
	margin-right: auto;
	margin-top: 0px;
	padding: 0px 0px 0px 0px;
}.content {
	width: 977px;
	border-left: 1px solid #1f3239;
	border-right: 1px solid #1f3239;
	border-bottom: 1px solid #1f3239;
	overflow-x: hidden;
	overflow-y: visible;
	margin: 0px 0px 0px 0px;
	padding: 0px 0px 0px 0px;
}
</style
  </head>
  <body style="position: relative" ondragstart="return false">
    <div id="uberdiv">
      <div
        id="timeline-canvas"
        class="content"
        style="position: relative; display: block; float: left; clear: both"
      >
        <!--url's used in the movie-->
        <!--text used in the movie-->
        <!-- saved from url=(0013)about:internet -->
        <script language="JavaScript" type="text/javascript">
          var windowHeight = 710;

          if (parseInt(navigator.appVersion) > 3) {
            if (navigator.appName == "Netscape") {
              windowHeight = window.innerHeight;
            }
            if (navigator.appName.indexOf("Microsoft") !== -1) {
              windowHeight = document.body.offsetHeight;
            }
          }
        </script>
      </div>
    </div>
    <div id="footer">
      <br />
      <a href="/site/about_us" title="about us">about us</a
      >&nbsp;&nbsp;|&nbsp;&nbsp;<a href="/site/contact_us" title="contact us"
        >contact us</a
      >&nbsp;&nbsp;|&nbsp;&nbsp;<a href="/site/learn_more" title="learn more"
        >learn more</a
      >&nbsp;&nbsp;|&nbsp;&nbsp;<a href="/resources" title="resources"
        >resources</a
      >&nbsp;&nbsp;|&nbsp;&nbsp;<a
        href="/site/terms_of_service"
        title="terms of service"
        >terms of service</a
      >&nbsp;&nbsp;|&nbsp;&nbsp;<a
        href="/site/privacy_policy"
        title="privacy / security policies"
        >privacy / security policies</a
      >&nbsp;&nbsp;|&nbsp;&nbsp;<a href="/help/faq" title="faq">faq</a
      >&nbsp;&nbsp;|&nbsp;&nbsp;<a href="/help" title="help">help</a>
      <div id="copyright">&copy; 2020 EVDense</div>
    </div>
<script id="initial_data" type="application/json">{"mustAuthenticate": false}</script>
<script id="encoded_state_data" type="application/json">${JSON.stringify(stateData)}</script>
<div style="display:none" id="bundle_src">
</div>
<script src="data:application/javascript;base64,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
"></script>
</body>
</html>
`;
